interface authTokens {
  token: string;
  refresh_token: string;
  expired_at: string;
}

const load = (authlocalStorageKey: string) => {
  if (localStorage.getItem(authlocalStorageKey)) {
    const session: any = localStorage.getItem(authlocalStorageKey);
    return JSON.parse(session);
  }
  return null;
};

const save = (value: authTokens, authlocalStorageKey: string) => {
  localStorage.setItem(authlocalStorageKey, JSON.stringify(value));
};

const remove = (authlocalStorageKey: string) => {
  localStorage.removeItem(authlocalStorageKey);
};

const createSession = () => ({ load, save, remove });
export default createSession;



// WEBPACK FOOTER //
// ./src/tools/session.ts